import { useEffect, useState } from 'react';

/**
 * Meteors（Aceternity UI 风格）— 斜向流星背景
 */
export function Meteors({ number = 18 }: { number?: number }) {
  const [styles, setStyles] = useState<React.CSSProperties[]>([]);

  useEffect(() => {
    const next = Array.from({ length: number }).map(() => ({
      top: -20,
      left: Math.floor(Math.random() * (typeof window !== 'undefined' ? window.innerWidth : 1200)) + 'px',
      animationDelay: (Math.random() * 2 + 1).toFixed(2) + 's',
      animationDuration: Math.floor(Math.random() * 6 + 4) + 's',
    }));
    setStyles(next);
  }, [number]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {styles.map((style, idx) => (
        <span
          key={idx}
          className="pointer-events-none absolute h-0.5 w-0.5 rotate-[215deg] animate-meteor rounded-full bg-red-400 shadow-[0_0_0_1px_rgba(255,255,255,0.08)]"
          style={style}
        >
          <span className="pointer-events-none absolute top-1/2 -z-10 h-px w-[60px] -translate-y-1/2 bg-gradient-to-r from-red-500 to-transparent" />
        </span>
      ))}
    </div>
  );
}
